import React from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { get, debounce } from 'lodash';
import { toast } from 'react-toastify';
import { Form } from 'informed';
import FormContainer from '../../containers/Form';
import AddButton from '../../components/buttons/AddButton';
import DeleteButton from '../../components/DeleteButton';
import { BaseForm } from '../../base';
import {
  InputText,
  InputSpan,
} from '../../components/inputs';
import { API_HOST } from '../../consts';
import Loading from '../../components/Loading';
import AddReferencia from '../../components/buttons/AddReferencia';
import { TrackGoogleAnalyticsEvent } from '../../utils/googleAnalytics';
import {ClickReferenciaBibliograficaObject, ClickReferenciaBibliograficaObjectAction} from '../../utils/googleAnalytics/events/Itens/EventReferenciaBibliograficaObject';

class ReferenciaBibliografica extends BaseForm {
  constructor(props) {
    super(props);
    this.formApis = {};
    this.add = this.add.bind(this);
    this.remove = this.remove.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this.fields = [
      'titulo',
      'autor',
      'capitulo',
      'pagina_inicial',
      'pagina_final',
      'link',
      'criado_por_ids'
    ];
    this.callApi = false;
  }


  state = {
    bibliografias: [],
    save: this.OK,
    fetchingData: true,
  }

  metadataModels = ['bibliografia', 'item']

  componentDidMount() {
    this.fetchData();
    this.fetchMetadata();
    this.fetchMe()
  }

  fetchMe() {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((response) => {
        this.setState({ me: response.data.id });
      })
      .catch((response) => console.log(response.error));
  }


  fetchData() {
    this.callApi = false;

    axios.get(`${API_HOST}/itens/bibliografia`, {
      params: {
        item: this.id,
      },
    })
      .then((response) => {
        this.setState({ bibliografias: response.data, fetchingData: false, criado_por: response.data[0] && response.data[0].criado_por_ids }, () => {
          response.data.forEach((x) => {
            const values = this.getValues(x);
            this.formApis[x.id].setValues(values);
          });
          setTimeout(() => { this.callApi = true; }, 1000);
        });
      });
  }

  add() {
    this.setState({ save: this.SALVANDO });

    axios.post(`${API_HOST}/itens/bibliografia`, {
      item: this.id,
    })
      .then((response) => {
        const { bibliografias } = this.state;
        bibliografias.push(response.data);
        this.setState({ bibliografias, save: this.SALVO });
      })
      .catch(() => {
        this.setState({ save: this.ERRO });
      });
  }

  remove(id) {
    this.setState({ save: this.SALVANDO });

    axios.delete(`${API_HOST}/itens/bibliografia/${id}`)
      .then(() => {
        const { bibliografias } = this.state;
        this.setState({
          bibliografias: bibliografias.filter(x => x.id !== id),
          save: this.SALVO,
        });
      })
      .catch(() => {
        this.setState({ save: this.ERRO });
      });
  }

  onValueChange = debounce((values, id) => {
    this.setState({ save: this.SALVANDO });

    axios.patch(`${API_HOST}/itens/bibliografia/${id}`, values)
      .then(() => {
        this.setState({ save: this.SALVO });
      })
      .catch(() => {
        this.setState({ save: this.ERRO });
      });
  }, 1000)

  onSubmit = (url) => {
    axios.get(`${API_HOST}/itens/item/${this.id}/validate?form=bibliografias`)
      .then(() => {
        const { history } = this.props;
        history.push(`/itens/${this.id}/${url}`);
      })
      .catch((error) => {
        this.onValidateError(error, 'bibliografias');
      });
  }

  onValidateError(error) {
    const status = get(error, 'response.status');

    if (status === 400) {
      const errors = get(error, 'response.data');
      const bibliografiaErrors = get(errors, 'bibliografias');
      const { bibliografias } = this.state;
      bibliografias.forEach((b, i) => {
        const bErrors = get(bibliografiaErrors, i);
        if (bErrors) {
          Object.keys(bErrors).forEach((be) => {
            this.formApis[b.id].setError(be, bErrors[be]);
          });
        }
      });

      this.renderErrorToast(errors);
    } else if (status !== 403) {
      toast.error('Ocorreu um erro inesperado.');
    }
  }

  renderErrorToast(errors) {
    const hasFieldErrors = get(errors, 'bibliografias.length', 0) > 0;
    const nonFieldErrors = get(errors, 'non_field_errors.bibliografias', []);

    toast.error((
      <React.Fragment>
        <ul>
          {hasFieldErrors && <li>Por favor, preencha os campos marcados como obrigatórios.</li>}
          {nonFieldErrors.map(e => <li key={e}>{e}</li>)}
        </ul>
      </React.Fragment>
    ));
  }

  analytcsWrite = (name, type) => {
    let label = "Write" + ": " + name
    let category = ClickReferenciaBibliograficaObject + "_" + type;

    TrackGoogleAnalyticsEvent(
      category,
      ClickReferenciaBibliograficaObjectAction,
      label,
    );
  }

  render() {
    const { bibliografias, fetchingData, me } = this.state;
    const { isDisabled } = this.props;

    if (fetchingData) {
      return <Loading />;
    }

    return (
      <FormContainer
        title="Referência bibliográfica"
        onClick={this.onSubmit}
        previous="matrizes-referencia"
        next="conteudo"
      >
        {
          <React.Fragment>
            {bibliografias.map(({ id }) => (
              <React.Fragment key={id}>
                <hr />
                <Form
                  onValueChange={(values) => {
                    if (this.callApi) {
                      this.setState({ save: this.MODIFICADO });
                      this.onValueChange(values, id);
                    }
                  }}
                  getApi={(formApi) => { this.formApis[id] = formApi; }}
                >
                  {() => {
                    if (fetchingData) {
                      return <Loading />;
                    }

                    return (
                      <div className="row" style={{backgroundColor:'white', padding:'14px', borderRadius:'8px'}}>
                        {this.shouldDisplay('bibliografia.titulo') && (
                          <InputText
                            disabled={isDisabled}
                            required={this.isRequired('bibliografia.titulo')}
                            col="col-sm-12"
                            label="Título material didático"
                            field="titulo"
                            style={{backgroundColor:'#FDFDFD'}}
                            onBlur = {(event)=>{
                              if(event.target.value){
                                this.analytcsWrite(`Título material didático: ${event.target.value}`, "InputText: Título material didático Writed Value")
                              }
                              else{
                                this.analytcsWrite(`Título material didático: Excluído`, "InputText: Título material didático Remove Value")
                              }
                            }}
                          />
                        )}
                        {this.shouldDisplay('bibliografia.autor') && (
                          <InputText
                            disabled={isDisabled}
                            required={this.isRequired('bibliografia.autor')}
                            col="col-sm-6"
                            label="Autor "
                            field="autor"
                            style={{backgroundColor:'#FDFDFD'}}
                            onBlur = {(event)=>{
                              if(event.target.value){
                                this.analytcsWrite(`Autor: ${event.target.value}`, "InputText: Autor Writed Value")
                              }
                              else{
                                this.analytcsWrite(`Autor: Excluído`, "InputText: Autor Remove Value")
                              }
                            }}
                          />
                        )}
                        {this.shouldDisplay('bibliografia.capitulo') && (
                          <InputText
                            disabled={isDisabled}
                            required={this.isRequired('bibliografia.capitulo')}
                            col="col-sm-6"
                            label="Capítulo"
                            field="capitulo"
                            style={{backgroundColor:'#FDFDFD'}}
                          />
                        )}
                        {this.shouldDisplay('bibliografia.pagina_inicial') && (
                          <InputSpan
                            disabled={isDisabled}
                            required={this.isRequired('bibliografia.pagina_inicial')}
                            col="col-sm-3"
                            label="Páginação"
                            rightAddon="Inicial"
                            style={{backgroundColor:'#FDFDFD'}}
                            field="pagina_inicial"
                            onBlur = {(event)=>{
                              if(event.target.value){
                                this.analytcsWrite(`Páginação Inicial: ${event.target.value}`, "InputText: Páginação Inicial Writed Value")
                              }
                              else{
                                this.analytcsWrite(`Páginação Inicial: Excluído`, "InputText: Páginação Inicial Remove Value")
                              }
                            }}
                          />
                        )}
                        {this.shouldDisplay('bibliografia.pagina_final') && (
                          <InputSpan
                            disabled={isDisabled}
                            required={this.isRequired('bibliografia.pagina_final')}
                            col="col-sm-3"
                            label="Páginação"
                            rightAddon="Final"
                            style={{backgroundColor:'#FDFDFD'}}
                            field="pagina_final"
                            onBlur = {(event)=>{
                              if(event.target.value){
                                this.analytcsWrite(`Páginação Final: ${event.target.value}`, "InputText: Páginação Final Writed Value")
                              }
                              else{
                                this.analytcsWrite(`Páginação Final: Excluído`, "InputText: Páginação Final Remove Value")
                              }
                            }}
                          />
                        )}
                        {this.shouldDisplay('bibliografia.link') && (
                          <InputText
                            disabled={isDisabled}
                            style={{backgroundColor:'#FDFDFD'}}
                            required={this.isRequired('bibliografia.link')}
                            col="col-sm-12"
                            label="Link (e-book)"
                            field="link"
                            onBlur = {(event)=>{
                              if(event.target.value){
                                this.analytcsWrite(`Link (e-book): ${event.target.value}`, "InputText: Link (e-book) Writed Value")
                              }
                              else{
                                this.analytcsWrite(`Link (e-book): Excluído`, "InputText: Link (e-book) Remove Value")
                              }
                            }}
                          />
                        )}
                        <div style={{width:'100%',display:'flex', alignItems:'center', justifyContent:'right',paddingRight:'4px'}}>
                          <button
                            disabled={isDisabled}
                            onClick={() => this.remove(id)}
                            style={{backgroundColor:'#E96240',border:'none', outline:'none',padding:'0px, 6px, 0px, 6px',
                            borderRadius: '8px', color:'white',marginRight:'14px'
                            }}>
                            Excluir
                          </button>
                        </div>

                      </div>
                    );
                  }}
                </Form>
              </React.Fragment>
            ))}
          </React.Fragment>
        }
        <AddReferencia
          disabled={isDisabled}
          title="Adicionar Referência"
          onClick={this.add}
          backgroundType = 'action'
        />
      </FormContainer>
    );
  }
}

export default withRouter(ReferenciaBibliografica);
